import { Button, Divider, Form, notification, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { hasValueInList } from '../../../../helpers/array';
import { showErrors } from '../../../../helpers/form';
import {
  validatePass,
  validatePermissions,
} from '../../../../helpers/validators';
import apiAuth from '../../../../services/apiAuth';
import FormDadosAcesso from './FormDadosAcesso';
import FormDadosPessoais from './FormDadosPessoais';
import Notificacao from './Notificacao';
import { Card, EditarButton } from './styles';

export default function TabMeuPerfil({
  user,
  selectedPermissions,
  setSelectedPermissions,
  setLoading,
  selectedPermissionsBack,
  setSelectedPermissionsBack,
}) {
  const [form] = Form.useForm();

  const requiredFields = ['name', 'email', 'phone_number', 'cpf', 'login'];

  const passFields = ['passConfirm', 'currentPass', 'strongPass'];

  const [isEditing, setIsEditing] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [isRequiredPassword, setIsRequiredPassword] = useState(false);
  const [pass, setPass] = useState('');

  useEffect(() => {
    form.setFieldsValue({
      name: user.name,
      email: user.email,
      phone_number: user.phone_number,
      cpf: user.cpf,
      login: user.login,
    });
  }, [user, form]);

  const handleEditing = () => {
    form.setFieldsValue({
      name: user.name,
      email: user.email,
      phone_number: user.phone_number,
      cpf: user.cpf,
      login: user.login,
      currentPass: null,
      passConfirm: null,
    });

    setPass(null);
    setIsEditing(!isEditing);
    setIsValid(false);

    setSelectedPermissions(selectedPermissionsBack);
  };

  useEffect(() => {
    async function getPermissionsBack() {
      if (selectedPermissionsBack.length <= 0) {
        setSelectedPermissionsBack(selectedPermissions);
      }
    }

    getPermissionsBack();
  }, [selectedPermissions]);

  const handleSubmitUser = async values => {
    try {
      const validatePassParams = {
        password: pass,
        passwordConfirm: form.getFieldValue('passConfirm'),
        isValidPass: isValidPassword,
      };

      if (
        validatePermissions(selectedPermissions) ||
        !validatePass(validatePassParams)
      ) {
        return;
      }

      setLoading(true);

      const updateValues = {
        name: values.name,
        phone_number: values.phone_number,
        email: values.email,
        cpf: values.cpf,
        users_permissions: selectedPermissions,
        currentPassword: values.currentPass,
        login: values.login,
        password: values.passConfirm,
      };

      await apiAuth.patch(`/users/${user.id}`, updateValues);

      notification.success({
        message: 'Tudo certo',
        description: 'Usuário atualizado com sucesso.',
      });

      form.setFieldsValue({
        currentPass: null,
        passConfirm: null,
      });
      setLoading(false);
      setIsEditing(false);
      setPass(null);
    } catch (error) {
      setLoading(false);
      const errors = error?.response?.data?.errors
        ? Object.values(error?.response?.data?.errors)
        : null;

      showErrors(errors);
    }
  };

  const validateRequiredForm = () => {
    const fieldsValue = form.getFieldsValue(requiredFields);
    const values = Object.values(fieldsValue);

    return values.filter(value => !value).length === 0;
  };

  const validatePassFields = () => {
    const fieldsValue = form.getFieldsValue(passFields);
    const countFieldsNoValues = Object.values(fieldsValue).filter(
      value => !value
    ).length;
    const valid = countFieldsNoValues === 0 || countFieldsNoValues === 3;

    setIsRequiredPassword(!valid);

    return valid;
  };

  const handleValidateForm = () => {
    let valid = validateRequiredForm();
    setIsValid(valid);

    if (!valid) return;

    valid = validatePassFields();
    setIsValid(valid);
  };

  const onSelectPermission = selectedId => {
    const permissoes = hasValueInList(selectedPermissions, 'id', selectedId)
      ? selectedPermissions.filter(({ id }) => id !== selectedId)
      : [...selectedPermissions, { id: selectedId }];

    setSelectedPermissions(permissoes);
    setIsValid(true);
  };

  const showEditButton = () => {
    if (isEditing) {
      return (
        <>
          <Button onClick={handleEditing}>Cancelar</Button>
          &nbsp;
          <Button
            disabled={!isValid}
            type="primary"
            htmlType="submit"
            onClick={form.submit}
          >
            Salvar
          </Button>
        </>
      );
    }

    return <EditarButton onClick={handleEditing}>Editar</EditarButton>;
  };

  return (
    <>
      <Row gutter={12} justify="end" className="pr-40">
        {showEditButton()}
      </Row>
      <Divider className="mt-10" />
      <Card className="pr-40 pl-40">
        <Form
          noValidate
          form={form}
          onFinish={handleSubmitUser}
          onValuesChange={handleValidateForm}
          layout="vertical"
          autoComplete="off"
        >
          <FormDadosPessoais isEditing={isEditing} />
          <FormDadosAcesso
            isEditing={isEditing}
            setIsValidPassword={setIsValidPassword}
            isRequiredPassword={isRequiredPassword}
            setPass={setPass}
          />
        </Form>

        <Notificacao
          selectedPermissions={selectedPermissions}
          onSelectPermission={onSelectPermission}
          isEditing={isEditing}
        />
      </Card>
    </>
  );
}

TabMeuPerfil.propTypes = {
  user: PropTypes.instanceOf(Object),
  selectedPermissions: PropTypes.instanceOf(Array),
  setSelectedPermissions: PropTypes.func,
  setLoading: PropTypes.func,
  selectedPermissionsBack: PropTypes.instanceOf(Array),
  setSelectedPermissionsBack: PropTypes.func,
};

TabMeuPerfil.defaultProps = {
  user: {},
  selectedPermissions: [],
  setSelectedPermissions: null,
  setLoading: null,
  selectedPermissionsBack: [],
  setSelectedPermissionsBack: null,
};
